'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult from "./app.pages.-Document-Templates-Create-Page$-Based-On-Result.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document(data) {
  this.M7 = null;
  this.M7 = data;
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document as $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document.prototype = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult.$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document as $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document };
$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document)) {
    var x = this.M7;
    var x$2 = x$0.M7;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Document";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.M7;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ki)));
}
export { $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document as $isArrayOf_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document };
var $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document, "app.pages.DocumentTemplatesCreatePage$BasedOnResult$Document", ({
  ki: 1,
  kh: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document as $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$Document };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Based-On-Result$-Document.js.map
